import React, { Component } from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import { Link } from 'react-router-dom';
import AdvancedCustomSettings from './AdvancedCustomSettings';
import BasciSettingsTab from './BasciSettingsTab';
import TeamSetting from './team/TeamSetting';
import ImportExportFiles from './importExport/ImportExportTabSettings';
import PaymentGateWaySettings from './PaymentGateWaySetting'
import ApiKeys from './ApiKeys';
import $ from 'jquery';
import EmailerSettings from './EmailerSetting';
import BillingSetting from './BillingSetting';
import WidgetSettingsTab from './WidgetSettingsTab';
import BotStore from '../testAndDeploy/appStore/AppStoreTabSetting';

class ProjectSettings extends Component {
  constructor() {
    super();
    this.state = {
      projectId: null,
      hideBotStore: false
    }
  }

  componentDidMount() {
    (function () {
      var currentPath = window.location.href;

      var path = window.origin + "/platform/projectmgmt/";
      var path1 = window.origin + "/platform/projectmgmt";
      if (currentPath === path || currentPath === path1 || currentPath.includes('/projectmgmt/domain') ||
        currentPath.includes('/projectmgmt/voice') || currentPath.includes('/projectmgmt/avatar-settings')) {
        $("#basicsettings").addClass('active');
      } else if (currentPath.includes("/projectmgmt/custom-settings") || currentPath.includes("/projectmgmt/custom-settings/")) {
        $("#custom-settings-tab").addClass('active');
      } else if (currentPath.includes("/projectmgmt/look-and-feel") || currentPath.includes("/projectmgmt/look-and-feel/")) {
        $("#look-and-feel").addClass('active');
      } else if (currentPath.includes("/projectmgmt/team") || currentPath.includes("/projectmgmt/team/")) {
        $("#team-tab").addClass('active');
      } else if (currentPath.includes("/projectmgmt/import-export") || currentPath.includes("/projectmgmt/import-export/")) {
        $("#import-export").addClass('active');
      } else if (currentPath.includes("/projectmgmt/api-keys") || currentPath.includes("/projectmgmt/api-keys/")) {
        $("#api-keys").addClass('active');
      } else if (currentPath.includes("/projectmgmt/emailer-settings") || currentPath.includes("/projectmgmt/emailer-settings/")) {
        $("#emailer-settings").addClass('active');
      } else if (currentPath.includes("/projectmgmt/billing-setting") || currentPath.includes("/projectmgmt/billing-setting/")) {
        $("#billing-setting").addClass('active');
      } else if (currentPath.includes("/projectmgmt/payment-gateway") || currentPath.includes("/projectmgmt/payment-gateway/")) {
        $("#payment-tab").addClass('active');
      } else if (currentPath.includes("/projectmgmt/bot-store") || currentPath.includes("/projectmgmt/bot-store/")) {
        $("#bot-store").addClass('active');
      }
      else {
        $("#" + localStorage.getItem("last-project-settings-tab")).addClass('active')
      }
      $("#bot-store,#custom-settings-tab,#look-and-feel,#basicsettings,#api-keys,#team-tab,#payment-tab,#import-export,#emailer-settings,#billing-setting")
        .on("click", function () {
          $("#bot-store,#custom-settings-tab,#basicsettings,#look-and-feel,#custom-settings-tab,#look-and-feel-tab,#team-tab,"
            + "#import-export,#api-keys,#payment-tab,#emailer-settings,#billing-setting")
            .removeClass('active');
          localStorage.setItem("last-project-settings-tab", $(this)[0].id);

          $(this).addClass('active')

        })

      $("#basicsettings").on("click", function () {
        $("#language,#domain,#voice,#avatar-settings")
          .removeClass('active');
        $("#language").addClass('active');
      })

      $("#import-export").on("click", function () {
        $("#import-export-subtab, #import-export-content")
          .removeClass('active');
        $("#import-export-subtab").addClass('active');
      })

      $("#team-tab").on("click", function () {
        $("#team-subtab,#org-tab, #support-team-subtab")
          .removeClass('active');
        $("#team-subtab").addClass('active');
      })

      $("#bot-store").on("click", function () {
        $("#store-basic-settings,#store-client-settings,#botstore-demo-config")
          .removeClass('active');
        $("#store-basic-settings").addClass('active');
      })

    })();
    if (localStorage.getItem("currentProjectId") == null) {
      this.getDetails();

    }
    this.getProjectDetails();


    var projectSettingComponent = this;
    projectSettingComponent.state.projectId = localStorage.getItem("currentProjectId");
    projectSettingComponent.setState(projectSettingComponent.state);
    document.addEventListener("projectChanged", function (event) {
      projectSettingComponent.projectId = event.projectId;
      projectSettingComponent.state.projectId = localStorage.getItem("currentProjectId");
      projectSettingComponent.setState(projectSettingComponent.state);
      projectSettingComponent.getProjectDetails(event.projectId);

    });
  }

  getDetails() {
    var projectSettingComponent = this;
    $.ajax({
      url: "/api/project",
      async: false,
      method: 'GET',
      data: { "userId": JSON.parse(localStorage.getItem("user_details"))["userId"] },
      headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
      success: function (res) {
        if (res.success === true) {
          localStorage.setItem("currentProjectId", res.result[0].id);
          projectSettingComponent.state.projectId = localStorage.getItem("currentProjectId");
          projectSettingComponent.setState(projectSettingComponent.state);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/platform/";
        }
      }
    });
  }
  getProjectDetails = (projectId) => {
    if (!projectId) {
      projectId = this.projectId;
      if (!projectId) {
        projectId = localStorage.getItem('currentProjectId');
      }
    }
    var detailsController = this;
    $.ajax({
      url: "/api/project-details",
      async: false,
      method: 'GET',
      data: {
        "projectId": projectId
      },
      headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
      success: function (res) {
        if (res.success === true) {
          if (res.result.isAnApp != null && res.result.isAnApp == true) {
            detailsController.state.hideBotStore = true;
            detailsController.setState(detailsController.state);
            if (window.location.href.includes("/projectmgmt/bot-store")) {
              window.location.href = "/platform/projectmgmt";
            } else if (window.location.href.includes("/projectmgmt/import-export")) {
              window.location.href = "/platform/projectmgmt";
            }

          } else {

            detailsController.state.hideBotStore = false;
            detailsController.setState(detailsController.state);
          }

        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/";
        }
      }
    });
  }

  render() {
    return (

      <div id="tabPage">
        <div className="content" style={{ backgroundColor: "#F9F9FB" }}>

          <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
          <title> Dheeyantra | Clusters Details</title>
          {/* Font Awesome Icons */}
          <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
          {/* IonIcons */}
          <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
          <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
          {/* Theme style */}
          <link rel="stylesheet" href="assets/css/adminlte.css" />
          <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
          <link rel="stylesheet" href="assets/css/custom-style.css" />
          <link rel="stylesheet" href="assets/css/styles.css" />
          <link rel="stylesheet" href="assets/css/custom-style.css" />
          <div className="content-header" >
            <div className="container-fluid">
              <div className="row">
                <div className="col-sm-5">
                  <h1 className="m-0 page-title" onClick={this.onClickBotSetting} onMouseOut={this.onclickMouseMoveOut}>Agent Settings</h1>
                  <h6 className="taglineTxt">Project Id: {this.state.projectId}</h6>
                </div>

              </div>
            </div>
          </div>

          <div className="container-fluid" >
            {/* Nav tabs */}
            <div className="border-bottom"></div>
            <div className="tab-class">

              <ul className="nav nav-tabs border-bottom navCluster">

                <Link className="nav-item" data-toggle="tab"
                  to="/projectmgmt" style={{ textDecoration: 'none' }}>
                  <li className="nav-link" id="basicsettings" style={{ marginRight: '15px' }}>
                    Basic
                  </li></Link>
                <Link className="nav-item" data-toggle="tab"
                  to="/projectmgmt/look-and-feel" style={{ textDecoration: 'none' }}>
                  <li className="nav-link" id="look-and-feel" style={{ marginRight: '15px' }}>
                    Widget
                  </li></Link>
                <Link className="nav-item" data-toggle="tab"
                  to="/projectmgmt/custom-settings" style={{ textDecoration: 'none' }}>
                  <li className="nav-link" id="custom-settings-tab" style={{ marginRight: '15px' }}>
                    Advanced
                  </li>
                </Link>
                <Link className="nav-item" data-toggle="tab"
                  to="/projectmgmt/import-export" style={{ textDecoration: 'none' }}>
                  <li className="nav-link" id="import-export" style={{ marginRight: '15px', display: this.state.hideBotStore ? 'none' : 'block' }}>
                    Import/Export
                  </li>
                </Link>

                <Link className="nav-item" data-toggle="tab"
                  to="/projectmgmt/api-keys" style={{ textDecoration: 'none' }}>
                  <li className="nav-link" id="api-keys" style={{ marginRight: '15px' }}>
                    API keys
                  </li>
                </Link>
                <Link className="nav-item" data-toggle="tab"
                  to="/projectmgmt/emailer-settings" style={{ textDecoration: 'none' }}>
                  <li className="nav-link" id="emailer-settings" style={{ marginRight: '15px' }}>
                    Emailer
                  </li>
                </Link>
                <Link className="nav-item" data-toggle="tab"
                  to="/projectmgmt/payment-gateway" style={{ textDecoration: 'none' }}>
                  <li className="nav-link" id="payment-tab" style={{ marginRight: '15px' }}>
                    Payment Gateway
                  </li>
                </Link>
                <Link className="nav-item" data-toggle="tab"
                  to="/projectmgmt/team-setting" style={{ textDecoration: 'none' }}>
                  <li className="nav-link" id="team-tab" style={{ marginRight: '15px' }}>
                    Team
                  </li>
                </Link>

                <Link className="nav-item" data-toggle="tab"
                  to="/projectmgmt/billing-setting" style={{ textDecoration: 'none' }}>
                  <li className="nav-link" id="billing-setting" style={{ marginRight: '15px' }}>
                    Billing
                  </li>
                </Link>

                <Link to="/projectmgmt/bot-store" className="nav-item" data-toggle="tab"
                  style={{ textDecoration: 'none' }}>
                  <li className="nav-link" id="bot-store" style={{ display: this.state.hideBotStore ? 'none' : 'block' }}>Bot Store</li>
                </Link>
              </ul>
            </div>
          </div>
        </div>
        <Switch>
          <Route path="/projectmgmt/bot-store" component={BotStore}></Route>
          <Route path="/projectmgmt/team-setting" component={TeamSetting}></Route>
          <Route path="/projectmgmt/billing-setting" component={BillingSetting}></Route>
          <Route path="/projectmgmt/payment-gateway" component={PaymentGateWaySettings}></Route>
          <Route path="/projectmgmt/emailer-settings" component={EmailerSettings}></Route>
          <Route path="/projectmgmt/api-keys" component={ApiKeys}></Route>
          <Route path="/projectmgmt/import-export" component={ImportExportFiles}></Route>
          <Route path="/projectmgmt/custom-settings" component={AdvancedCustomSettings}></Route>
          <Route path="/projectmgmt/look-and-feel" component={WidgetSettingsTab}></Route>
          <Route path="/projectmgmt" component={BasciSettingsTab}></Route>
        </Switch>
      </div>

    );
  }
}
export default ProjectSettings;




// WEBPACK FOOTER //
// ./src/projectmgmt/settings/ProjectSettings.js